import { t } from '../../i18n';
import { useEffect, useState } from 'react';

const IntroSection = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 600);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="mb-12">
      <p
        className={`text-lg md:text-xl text-foreground/70 leading-relaxed max-w-xl transition-all duration-1000 ease-out-expo ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
        }`}
      >
        {t("I'm a")}{' '}
        <span className="text-foreground font-medium">{t("web developer")}</span> {t("and")}{' '}
        <span className="text-foreground font-medium">{t("AI specialist")}</span> {t("based in Angers, France. I create innovative digital solutions and leverage cutting-edge technology to solve complex problems for businesses.")}
      </p>
    </section>
  );
};

export default IntroSection;
